(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('darkModeSvc', darkModeSvc);

    darkModeSvc.$inject = ['$rootScope', '$window'];

    function darkModeSvc($rootScope, $window) {
        var STORAGE_KEY = 'endeksa-dark-mode';
        var service = {
            initialize: initialize,
            toggle: toggle,
            setDarkMode: setDarkMode,
            isDarkMode: isDarkMode,
            applyTheme: applyTheme
        };

        return service;

        /**
         * Initialize dark mode on app startup
         * Checks localStorage first, then device preference, then user profile
         */
        function initialize() {
            var darkModeEnabled = getDarkModePreference();
            applyTheme(darkModeEnabled);

            // Listen for device theme changes
            if ($window.matchMedia) {
                var darkModeMediaQuery = $window.matchMedia('(prefers-color-scheme: dark)');

                // Modern browsers
                if (darkModeMediaQuery.addEventListener) {
                    darkModeMediaQuery.addEventListener('change', function (e) {
                        // Only auto-update if user hasn't manually set preference
                        if (!hasManualPreference()) {
                            applyTheme(e.matches);
                        }
                    });
                }
                // Legacy browsers
                else if (darkModeMediaQuery.addListener) {
                    darkModeMediaQuery.addListener(function (e) {
                        if (!hasManualPreference()) {
                            applyTheme(e.matches);
                        }
                    });
                }
            }
        }

        /**
         * Toggle dark mode on/off
         */
        function toggle() {
            var currentMode = isDarkMode();
            var newMode = !currentMode;
            setDarkMode(newMode);
            return newMode;
        }

        /**
         * Set dark mode explicitly
         * @param {boolean} enabled - True to enable dark mode
         */
        function setDarkMode(enabled) {
            // Save to localStorage for persistence
            try {
                $window.localStorage.setItem(STORAGE_KEY, enabled ? 'dark' : 'light');
            } catch (e) {
                console.warn('Failed to save dark mode preference:', e);
            }

            applyTheme(enabled);

            // Broadcast event for other components to react
            $rootScope.$broadcast('darkMode:changed', { enabled: enabled });
        }

        /**
         * Check if dark mode is currently active
         * @returns {boolean}
         */
        function isDarkMode() {
            return document.documentElement.classList.contains('dark-mode');
        }

        /**
         * Apply or remove dark theme class
         * @param {boolean} enabled - True to enable dark mode
         */
        function applyTheme(enabled) {
            var htmlElement = document.documentElement;
            var bodyElement = document.body;

            if (enabled) {
                htmlElement.classList.add('dark-mode');
                bodyElement.classList.add('dark-mode');
                $window.darkMode = true;
            } else {
                htmlElement.classList.remove('dark-mode');
                bodyElement.classList.remove('dark-mode');
                $window.darkMode = false;
            }

            // Update rootScope theme if it exists
            if ($rootScope.theme) {
                $rootScope.theme.selected = enabled ? 2 : 1;
            }
        }

        /**
         * Get dark mode preference from various sources
         * Priority: localStorage > userProfile > device preference
         * @returns {boolean}
         */
        function getDarkModePreference() {
            // 1. Check localStorage (manual user preference)
            try {
                var storedPreference = $window.localStorage.getItem(STORAGE_KEY);
                if (storedPreference === 'dark') {
                    return true;
                }
                if (storedPreference === 'light') {
                    return false;
                }
            } catch (e) {
                console.warn('Failed to read dark mode preference from localStorage:', e);
            }

            // 2. Check if user profile has dark mode setting (when user is signed in)
            if ($rootScope.userSvc && $rootScope.userSvc.info && $rootScope.userSvc.info.SignedIn) {
                if ($rootScope.userSvc.info.Details &&
                    $rootScope.userSvc.info.Details.profile &&
                    $rootScope.userSvc.info.Details.profile.useDarkMode !== undefined) {
                    return $rootScope.userSvc.info.Details.profile.useDarkMode;
                }
            }

            // 3. Check device preference (system theme)
            if ($window.matchMedia && $window.matchMedia('(prefers-color-scheme: dark)').matches) {
                return true;
            }

            // 4. Default to light mode
            return false;
        }

        /**
         * Check if user has manually set a preference in localStorage
         * @returns {boolean}
         */
        function hasManualPreference() {
            try {
                var storedPreference = $window.localStorage.getItem(STORAGE_KEY);
                return storedPreference === 'dark' || storedPreference === 'light';
            } catch (e) {
                return false;
            }
        }
    }
})();
